import { render } from "./trash.vue?vue&type=template&id=41361584"
const script = {}

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Scripts/icons/trash.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "41361584"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('41361584', __exports__)) {
    api.reload('41361584', __exports__)
  }
  
  module.hot.accept("./trash.vue?vue&type=template&id=41361584", () => {
    api.rerender('41361584', render)
  })

}


export default __exports__